const features = [
  {
    title: '2024娱乐圈塌房年鉴',
    desc: '回顾今年最震撼的明星翻车事件合集',
    tag: '年度盘点',
    img: 'https://readdy.ai/api/search-image?query=cinematic%20year%20in%20review%20collage%20with%20dramatic%20red%20and%20dark%20tones%2C%20entertainment%20news%20aesthetic%2C%20newspaper%20headlines%20style%2C%20moody%20atmosphere%20with%20warm%20highlights%2C%20professional%20editorial%20design&width=1200&height=600&seq=carousel-51hlw-01&orientation=landscape',
  },
  {
    title: '顶流艺人生存现状调查',
    desc: '深扒流量明星背后的商业版图与危机',
    tag: '深度调查',
    img: 'https://readdy.ai/api/search-image?query=investigative%20journalism%20atmosphere%20with%20dramatic%20lighting%2C%20detective%20board%20with%20red%20strings%20and%20photos%2C%20dark%20moody%20office%2C%20warm%20desk%20lamp%20glow%2C%20mystery%20investigation%20vibe&width=1200&height=600&seq=carousel-51hlw-02&orientation=landscape',
  },
  {
    title: '综艺节目剧本门大起底',
    desc: '揭秘热门综艺背后的套路与操作手法',
    tag: '行业揭秘',
    img: 'https://readdy.ai/api/search-image?query=reality%20TV%20production%20control%20room%20with%20multiple%20monitors%2C%20dramatic%20behind%20the%20scenes%20atmosphere%2C%20professional%20broadcast%20environment%2C%20dark%20room%20with%20screen%20glow%2C%20cinematic&width=1200&height=600&seq=carousel-51hlw-03&orientation=landscape',
  },
  {
    title: '网红产业链灰色地带',
    desc: '从签约到翻车，MCN机构的流量生意经',
    tag: '产业链',
    img: 'https://readdy.ai/api/search-image?query=modern%20office%20with%20multiple%20screens%20showing%20social%20media%20analytics%2C%20digital%20marketing%20atmosphere%2C%20warm%20ambient%20lighting%2C%20professional%20workspace%2C%20dark%20background%20with%20screen%20glow&width=1200&height=600&seq=carousel-51hlw-04&orientation=landscape',
  },
  {
    title: '影视圈税务风暴追踪',
    desc: '从个体艺人到制作公司，税务合规大扫描',
    tag: '持续关注',
    img: 'https://readdy.ai/api/search-image?query=government%20building%20silhouette%20at%20sunset%20with%20dramatic%20sky%2C%20official%20documents%20and%20stamps%20on%20desk%2C%20serious%20legal%20atmosphere%2C%20warm%20desk%20lamp%20lighting%2C%20investigative%20mood&width=1200&height=600&seq=carousel-51hlw-05&orientation=landscape',
  },
  {
    title: '吃瓜群众心理学研究',
    desc: '为什么我们对明星塌房欲罢不能？',
    tag: '趣味解读',
    img: 'https://readdy.ai/api/search-image?query=audience%20silhouettes%20watching%20big%20screen%20with%20dramatic%20lighting%2C%20cinema%20atmosphere%2C%20people%20engrossed%20in%20entertainment%2C%20dark%20theater%20with%20warm%20screen%20glow%2C%20editorial%20photography&width=1200&height=600&seq=carousel-51hlw-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">深度专题</span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">焦点专题</h2>
          <p className="text-foreground-600 text-sm mt-2">编辑部精心策划的深度吃瓜专题</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((f, i) => (
            <div key={i} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer transition-all hover:border-primary-200">
              <div className="relative aspect-[2/1] overflow-hidden bg-background-200">
                <img
                  src={f.img}
                  alt={`51黑料网专题 - ${f.title}`}
                  title={`51黑料网深度专题 - ${f.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).parentElement!.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold">
                    {f.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">{f.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}